module.exports = __webpack_public_path__ + "static/img/bg-en.d6ca8c9f.png";